import React from "react";
import { NavigationLinks } from "./NavigationLinks";

export const NavigationFooter: React.FC = () => {
  return (
    <div className="flex flex-wrap justify-center items-center gap-3">
      <NavigationLinks variant="footer"/>
    </div>
  );
};
